





































import mixins from 'vue-typed-mixins';
import { mapMutationsDvm } from '@/main/pages';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { store } from '@/modules/sklad/pneuSklad/store/edit';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { EventBus } from '@/main/eventBus';

import rozmery from './Rozmery.vue';
import { genPneuComputeds } from './pneuHelpers';
// eslint-disable-next-line no-unused-vars
import { Pneu, PneuPart } from '../store/types';

export default mixins(PageModeMixin).extend({
	name: 'Pneu',
	components: {
		rozmery,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
		index: { type: Number, required: true },
		lg: { type: Number },
		pneuFormName: { type: String, required: true },
		disabled: { type: Boolean },
	},
	computed: {
		...genVuexComputeds(store),
		...genPneuComputeds(),
		pneu(): Pneu {
			return this.polozky.data[this.index];
		},
		validator() : Function {
			if (this.$refs[this.pneuFormName]) {
				return (this.$refs[this.pneuFormName] as any).validate;
			}
			return () => {};
		},
	},
	watch: {
		DiskPrp() {
			this.updatePolozkyValidationRules({ index: this.index, pneuPart: PneuPart.Disk });
		},
		PneuPrp() {
			this.updatePolozkyValidationRules({ index: this.index, pneuPart: PneuPart.Pneu });
		},
		disabled(disabled) {
			EventBus.$emit('DisableAll', disabled);
		},
	},
	methods: {
		...mapMutationsDvm(store.mutations),
		async validate() {
			if (this.DiskPrp || this.PneuPrp) {
				let isPneuValid = false;
				const validateCallBack = (isValid?: boolean) => {
					if (isValid) {
						isPneuValid = true;
					} else {
						this.showErrorAlert({ message: 'InvalidForm' });
					}
				};
				await this.validator(validateCallBack);
				return isPneuValid;
			}
			return true;
		},
	},
	updated() {
		EventBus.$emit('Mode', this.pageMode);
	},
	mounted() {
		EventBus.$emit('Mode', this.pageMode);
		EventBus.$emit('DisableAll', this.disabled);
	},
});
